import React from 'react'
import { Breadcrumb, Tabs } from 'antd'
import { RouteComponentProps } from 'react-router'
import { filter, sortBy, map, uniq } from 'lodash'
import { ComponentExt } from 'util/reactExt'
import * as styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {
  tab: string[]
  tabDetails: any
  filterTab: any
}

class Gather extends ComponentExt<IProps, IState> {
  state = {
    tab: [],
    tabDetails: [],
    filterTab: [],
  }

  componentDidMount() {
    const id = new URLSearchParams(this.props.location.search).get('id')
    this.handleGloryTabDetails(Number(id))
  }

  async handleGloryTabDetails(id: number) {
    try {
      const { data } = await this.api.lecturer.getLecturerGloryTabDetails({
        id,
      })
      this.setState({ tabDetails: data, filterTab: data })
      let tab = uniq(map(sortBy(data, 'first_spell'), 'first_spell'))
      tab = ['全部', ...tab]
      this.setState({ tab })
    } catch (err) {
      console.error(err.message)
    }
  }

  tabClick = key => {
    const { tabDetails } = this.state
    if (key === '全部') {
      this.setState({ filterTab: tabDetails })
    } else {
      const filterTab = filter(tabDetails, { first_spell: key })
      this.setState({ filterTab })
    }
  }

  render() {
    const { tab, filterTab } = this.state
    const { TabPane } = Tabs

    return (
      <div className={`${styles.wrapper} gatherWrap`}>
        <Breadcrumb separator=">">
          <Breadcrumb.Item href={`/#/glory?time=${Date.now()}`}>
            荣耀殿堂
          </Breadcrumb.Item>
          <Breadcrumb.Item>投资顾问</Breadcrumb.Item>
        </Breadcrumb>

        <h2 className={styles.title}>
          <p>投资顾问</p>
        </h2>

        <Tabs type="card" onTabClick={this.tabClick}>
          {tab.map(item => (
            <TabPane tab={item} key={item}>
              {filterTab.map(item => (
                <div className={styles.list} key={item.staff_id}>
                  <img src={item.head_img} alt={item.name} />
                  <p>{item.name}</p>
                </div>
              ))}
            </TabPane>
          ))}
        </Tabs>
      </div>
    )
  }
}

export default Gather
